import { render, staticRenderFns } from "./bargin.vue?vue&type=template&id=5410b482&scoped=true"
import script from "./bargin.vue?vue&type=script&lang=js"
export * from "./bargin.vue?vue&type=script&lang=js"
import style0 from "./bargin.vue?vue&type=style&index=0&id=5410b482&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5410b482",
  null
  
)

export default component.exports